import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { unblockCompany } from "../api/unblockCompany";

export const useUnblockCompany = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (companyId) => unblockCompany(companyId),
    onSuccess: () => {
      toast.success("Company unblocked successfully!");
      queryClient.invalidateQueries({ queryKey: ["subscriptionDetails"] });
      queryClient.invalidateQueries({ queryKey: ["allSubscriptions"] });
    },
    onError: (error) => {
      toast.error(error.message || "Failed to unblock company.");
    },
  });
};

